import clsx from "clsx";
import { useMySavedColorsModalStore } from "../../../js/stores/my-saved-colors-modal-store";
import { useMySavedColors } from "../../my-saved-colors";
import { useMyLikedColorsStore } from "../../../js/stores/my-liked-colors-store";
import { useSavedColors } from "../../../js/api/my-saved-colors/get-saved-colors";
import { useSyncLoaderStore } from "../../../js/stores/sync-loader-store";
import { SharedIcon } from "../shared/shared-icon";

function HeartHeaderButton({ clickHandler, colorCount, className }) {
  return (
    <div className={clsx("icon-bg", className)}>
      <button
        type="button"
        className="header__actions-item header-basket-icon site-header__cart icon-bg"
        aria-label="My Saved Colours"
        onClick={(e) => clickHandler(e)}
      >
        <SharedIcon
          iconName="#sprite-heart"
          className="icon--chip-nav cart-opener"
        />
        <span className="site-header__color-count">{colorCount}</span>
      </button>
    </div>
  );
}

function LikedHeartHeaderButton() {
  const isLikedStoreReady = useMyLikedColorsStore(
    (state) => state._hasHydrated
  );
  const likedColors = useMyLikedColorsStore((state) => state.likedColors);
  const colorCount = likedColors?.length || 0;
  const openModal = useMySavedColorsModalStore((state) => state.openModal);

  return (
    <>
      {isLikedStoreReady && (
        <HeartHeaderButton clickHandler={openModal} colorCount={colorCount} />
      )}
      {!isLikedStoreReady && <div />}
    </>
  );
}

function SavedHeartHeaderButton() {
  const { initialColorsCount } = useMySavedColors();
  const { data, status } = useSavedColors();
  const apiCount = data?.totalCount || 0;
  const isQueryReady = status === "success";
  const colorCount = isQueryReady ? apiCount : initialColorsCount;
  const openModal = useMySavedColorsModalStore((state) => state.openModal);

  return <HeartHeaderButton clickHandler={openModal} colorCount={colorCount} />;
}

function SpinnerHeaderButton() {
  return (
    <div className="header__actions-item header-basket-icon site-header__cart icon-bg">
      <SharedIcon
        iconName="#sprite-spinner"
        className="icon--chip-nav cart-opener animate-spin"
      />
    </div>
  );
}

export function MySavedColorsButton() {
  const isSyncingLikedColors = useSyncLoaderStore((state) => state.isLoading);
  const { isLoggedIn } = useMySavedColors();

  return (
    <div>
      {isSyncingLikedColors ? (
        <SpinnerHeaderButton />
      ) : isLoggedIn ? (
        <SavedHeartHeaderButton />
      ) : (
        <LikedHeartHeaderButton />
      )}
    </div>
  );
}
